module.exports = {
          srcSet: __webpack_public_path__ + "public/images/fc70e85865406e4a460a062a9725e7bd-1200.jpg"+" 1200w",
          images:[ {path: __webpack_public_path__ + "public/images/fc70e85865406e4a460a062a9725e7bd-1200.jpg",width: 1200,height: 800}],
          src: __webpack_public_path__ + "public/images/fc70e85865406e4a460a062a9725e7bd-1200.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/fc70e85865406e4a460a062a9725e7bd-1200.jpg"},
          
          width: 1200,
          height: 800
        }